module.exports = __webpack_public_path__ + "img/horizontal_7_4_3.1cf657ea.png";